module.exports = __webpack_public_path__ + "img/Legacy-Sensor.5edda65f.svg";